import { render } from "./choose-bear-item.vue?vue&type=template&id=41500436&scoped=true&ts=true"
import script from "./choose-bear-item.vue?vue&type=script&lang=ts"
export * from "./choose-bear-item.vue?vue&type=script&lang=ts"

import "./choose-bear-item.vue?vue&type=style&index=0&id=41500436&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41500436"]])

export default __exports__